import PropTypes from 'prop-types'

import NewsletterForm from '@adv-mt/mt-newsletter-form'

export const SidebarNewsletterForm = ({pageName}) => {
  return <NewsletterForm pageName={pageName} />
}

SidebarNewsletterForm.propTypes = {
  pageName: PropTypes.string.isRequired
}
